import type { RouteRecordRaw } from "vue-router";

import { pages } from "@/content/pages";
import NotFoundView from "@/views/NotFoundView.vue";
import PageView from "@/views/PageView.vue";

export const routes: RouteRecordRaw[] = [
  { path: "/privacy", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy/", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-policy", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-policy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-policy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy_policy", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy_policy/", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy_policy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy_policy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/privacypolicy", redirect: "/privacy-policy/", strict: true },
  { path: "/privacypolicy/", redirect: "/privacy-policy/", strict: true },
  { path: "/privacypolicy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacypolicy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-notice", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-notice/", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-notice.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-notice.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy/", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy-policy", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy-policy/", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy-policy.html", redirect: "/privacy-policy/", strict: true },
  { path: "/legal/privacy-policy.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/terms", redirect: "/terms-of-service/", strict: true },
  { path: "/terms/", redirect: "/terms-of-service/", strict: true },
  { path: "/terms.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-service", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-service.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-service.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-use", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-use/", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-use.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-use.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-and-conditions", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-and-conditions/", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-and-conditions.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-and-conditions.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-conditions", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-conditions/", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-conditions.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-conditions.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/terms_conditions", redirect: "/terms-of-service/", strict: true },
  { path: "/terms_conditions/", redirect: "/terms-of-service/", strict: true },
  { path: "/terms_conditions.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms_conditions.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/tos", redirect: "/terms-of-service/", strict: true },
  { path: "/tos/", redirect: "/terms-of-service/", strict: true },
  { path: "/tos.html", redirect: "/terms-of-service/", strict: true },
  { path: "/tos.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/legal/terms", redirect: "/terms-of-service/", strict: true },
  { path: "/legal/terms/", redirect: "/terms-of-service/", strict: true },
  { path: "/legal/terms.html", redirect: "/terms-of-service/", strict: true },
  { path: "/legal/terms.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/refund", redirect: "/refund-policy/", strict: true },
  { path: "/refund/", redirect: "/refund-policy/", strict: true },
  { path: "/refund.html", redirect: "/refund-policy/", strict: true },
  { path: "/refund.htm", redirect: "/refund-policy/", strict: true },
  { path: "/refunds", redirect: "/refund-policy/", strict: true },
  { path: "/refunds/", redirect: "/refund-policy/", strict: true },
  { path: "/refunds.html", redirect: "/refund-policy/", strict: true },
  { path: "/refunds.htm", redirect: "/refund-policy/", strict: true },
  { path: "/refund-policy", redirect: "/refund-policy/", strict: true },
  { path: "/refund-policy.html", redirect: "/refund-policy/", strict: true },
  { path: "/refund-policy.htm", redirect: "/refund-policy/", strict: true },
  { path: "/refund_policy", redirect: "/refund-policy/", strict: true },
  { path: "/refund_policy/", redirect: "/refund-policy/", strict: true },
  { path: "/refund_policy.html", redirect: "/refund-policy/", strict: true },
  { path: "/refund_policy.htm", redirect: "/refund-policy/", strict: true },
  { path: "/refunds-policy", redirect: "/refund-policy/", strict: true },
  { path: "/refunds-policy/", redirect: "/refund-policy/", strict: true },
  { path: "/refunds-policy.html", redirect: "/refund-policy/", strict: true },
  { path: "/refunds-policy.htm", redirect: "/refund-policy/", strict: true },
  { path: "/cancellation-policy", redirect: "/refund-policy/", strict: true },
  { path: "/cancellation-policy/", redirect: "/refund-policy/", strict: true },
  { path: "/cancellation-policy.html", redirect: "/refund-policy/", strict: true },
  { path: "/cancellation-policy.htm", redirect: "/refund-policy/", strict: true },
  { path: "/legal/refunds", redirect: "/refund-policy/", strict: true },
  { path: "/legal/refunds/", redirect: "/refund-policy/", strict: true },
  { path: "/legal/refunds.html", redirect: "/refund-policy/", strict: true },
  { path: "/legal/refunds.htm", redirect: "/refund-policy/", strict: true },
  { path: "/contact", redirect: "/support/#contact", strict: true },
  { path: "/contact/", redirect: "/support/#contact", strict: true },
  { path: "/contact.html", redirect: "/support/#contact", strict: true },
  { path: "/contact.htm", redirect: "/support/#contact", strict: true },
  { path: "/contact-us", redirect: "/support/#contact", strict: true },
  { path: "/contact-us/", redirect: "/support/#contact", strict: true },
  { path: "/contact-us.html", redirect: "/support/#contact", strict: true },
  { path: "/contact-us.htm", redirect: "/support/#contact", strict: true },
  { path: "/contact_us", redirect: "/support/#contact", strict: true },
  { path: "/contact_us/", redirect: "/support/#contact", strict: true },
  { path: "/contact_us.html", redirect: "/support/#contact", strict: true },
  { path: "/contact_us.htm", redirect: "/support/#contact", strict: true },
  { path: "/contactus", redirect: "/support/#contact", strict: true },
  { path: "/contactus/", redirect: "/support/#contact", strict: true },
  { path: "/contactus.html", redirect: "/support/#contact", strict: true },
  { path: "/contactus.htm", redirect: "/support/#contact", strict: true },
  { path: "/help", redirect: "/support/#contact", strict: true },
  { path: "/help/", redirect: "/support/#contact", strict: true },
  { path: "/help.html", redirect: "/support/#contact", strict: true },
  { path: "/help.htm", redirect: "/support/#contact", strict: true },
  { path: "/help-center", redirect: "/support/#contact", strict: true },
  { path: "/help-center/", redirect: "/support/#contact", strict: true },
  { path: "/help-center.html", redirect: "/support/#contact", strict: true },
  { path: "/help-center.htm", redirect: "/support/#contact", strict: true },
  { path: "/report-a-bug", redirect: "/support/#contact", strict: true },
  { path: "/report-a-bug/", redirect: "/support/#contact", strict: true },
  { path: "/report-a-bug.html", redirect: "/support/#contact", strict: true },
  { path: "/report-a-bug.htm", redirect: "/support/#contact", strict: true },
  { path: "/privacy-policy/index.html", redirect: "/privacy-policy/", strict: true },
  { path: "/privacy-policy/index.htm", redirect: "/privacy-policy/", strict: true },
  { path: "/terms-of-service/index.html", redirect: "/terms-of-service/", strict: true },
  { path: "/terms-of-service/index.htm", redirect: "/terms-of-service/", strict: true },
  { path: "/refund-policy/index.html", redirect: "/refund-policy/", strict: true },
  { path: "/refund-policy/index.htm", redirect: "/refund-policy/", strict: true },
  { path: "/support", redirect: "/support/", strict: true },
  { path: "/support.html", redirect: "/support/#contact", strict: true },
  { path: "/support.htm", redirect: "/support/#contact", strict: true },
  { path: "/support/index.html", redirect: "/support/#contact", strict: true },
  { path: "/support/index.htm", redirect: "/support/#contact", strict: true },
  ...pages.map((page) => ({
    path: page.path,
    name: page.path === "/" ? "home" : page.path.slice(1, -1),
    component: PageView,
    props: { page },
  })),
  { path: "/404/", name: "static-not-found", component: NotFoundView },
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFoundView },
];
